"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.weak-map.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.promise.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.array.concat.js");

var _find2 = _interopRequireDefault(require("lodash/find"));

var _debounce2 = _interopRequireDefault(require("lodash/debounce"));

var _each2 = _interopRequireDefault(require("lodash/each"));

var _includes = _interopRequireDefault(require("lodash/includes"));

var _clipboard = _interopRequireDefault(require("clipboard"));

var _renderer = _interopRequireDefault(require("./renderer"));

var _export = _interopRequireDefault(require("./tpl/partial/export"));

var _constants = _interopRequireDefault(require("./constants"));

var _utils = _interopRequireWildcard(require("./utils"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Constructor for the Dom Wrapper
 * Dom Wrapper's function is to place rendered Zotero Publications
 * into a DOM container and handle events
 * @param {HTMLElement} container				- A container where contents is rendered
 * @param {ZoteroPublications} [zotero]			- ZoteroPublications object
 */
function DomWrapper(container, zotero) {
  this.container = container;
  this.zotero = zotero;
  this.config = zotero.config;
  this.renderer = new _renderer.default(zotero);

  if (this.config.storeCitationPreference) {
    this.preferredCitationStyle = localStorage.getItem('zotero-citation-preference');
  } else {
    this.preferredCitationStyle = '';
  }

  this.toggleSpinner(true);
}
/**
 * Render Zotero publications into a DOM element
 * @param  {ZoteroData} data       - Source of publications to be rendered
 */


DomWrapper.prototype.displayPublications = function (data) {
  var markup;
  this.renderer.data = this.data = data;

  if (data.grouped > 0) {
    markup = this.renderer.renderGroupView(data);
  } else {
    markup = this.renderer.renderPlainView(data);
  }

  this.container.innerHTML = markup;
  this.toggleSpinner(false);
  this.previous = markup;
  this.addHandlers();
  this.updateVisuals();
};
/**
 * Update citation and store preference in memory/local storage
 * depending on configuration
 * @param  {HTMLElement} itemEl 		- dom element containing the item
 * @param  {String} citationStyle 		- optionally set the citation style
 */


DomWrapper.prototype.updateCitation = function (itemEl, citationStyle) {
  var _this = this;

  var itemId = itemEl.getAttribute('data-item');
  var citationEl = itemEl.querySelector('.zotero-citation');
  var citationStyleSelectEl = itemEl.querySelector('[data-trigger="cite-style-selection"]');

  if (citationStyle) {
    citationStyleSelectEl.value = citationStyle;
  } else {
    citationStyle = citationStyleSelectEl.options[citationStyleSelectEl.selectedIndex].value;
  }

  this.preferredCitationStyle = citationStyle;

  if (this.config.storeCitationPreference) {
    localStorage.setItem('zotero-citation-preference', citationStyle);
  }

  citationEl.innerHTML = '';
  citationEl.classList.add('zotero-loading-inline');
  return new Promise(function (resolve, reject) {
    _this.zotero.getPublication(itemId, _this.zotero.userId, {
      'style': citationStyle,
      'include': ['bib'],
      'group': false
    }).then(function (item) {
      citationEl.classList.remove('zotero-loading-inline');
      citationEl.innerHTML = item.raw[0].bib;
      resolve();
    }).catch(reject);
  });
};
/**
 * Prepare a link for downloading item export
 * @param {HTMLElement} [itemEl] - dom element containing the item
 */


DomWrapper.prototype.prepareExport = function (itemEl) {
  var _this2 = this;

  var itemId = itemEl.getAttribute('data-item');
  var exportEl = itemEl.querySelector('.zotero-export');
  var exportFormatSelectEl = itemEl.querySelector('[data-trigger="export-format-selection"]');
  var exportFormat = exportFormatSelectEl.options[exportFormatSelectEl.selectedIndex].value;
  exportEl.innerHTML = '';
  exportEl.classList.add('zotero-loading-inline');
  this.zotero.getPublication(itemId, this.zotero.userId, {
    'include': [exportFormat],
    'group': false
  }).then(function (item) {
    var itemData = (0, _find2.default)(_this2.data.raw, {
      'key': itemId
    });
    var encoded = window.btoa(unescape(encodeURIComponent(item.raw[0][exportFormat])));
    exportEl.classList.remove('zotero-loading-inline');
    exportEl.innerHTML = (0, _export.default)({
      'filename': itemData.data.title + '.' + _this2.zotero.config.exportFormats[exportFormat].extension,
      'content': encoded,
      'contentType': _this2.zotero.config.exportFormats[exportFormat].contentType,
      constants: _constants.default,
      utils: _utils.default
    });
  });
};
/**
 * Attach interaction handlers
 */


DomWrapper.prototype.addHandlers = function () {
  var _this3 = this;

  var clipboard = new _clipboard.default('.zotero-citation-copy');
  Array.from(this.container.querySelectorAll('.zotero-details.zotero-collapsable')).forEach(function (element) {
    element.style.height = 0 + 'px';
    element.setAttribute('data-collapsed', 'true');
  });
  clipboard.on('success', function (e) {
    e.clearSelection();
    e.trigger.setAttribute('aria-label', 'Copied!');
  });
  clipboard.on('error', function (e) {
    e.trigger.setAttribute('aria-label', (0, _utils.clipboardFallbackMessage)(e.action));
  });
  this.container.addEventListener('mouseout', function (ev) {
    if (ev.target.classList.contains('zotero-citation-copy')) {
      ev.target.blur();
      ev.target.setAttribute('aria-label', 'Copy to clipboard');
    }
  });
  this.container.addEventListener('click', function (ev) {
    var target;
    target = (0, _utils.closest)(ev.target, function (el) {
      return el.hasAttribute && el.hasAttribute('data-trigger');
    });

    if (target) {
      ev.preventDefault();
      var itemEl = (0, _utils.closest)(target, function (el) {
        return el.hasAttribute && el.hasAttribute('data-item');
      });

      if (target.getAttribute('data-trigger') === 'details') {
        _this3.toggleDetails(itemEl);
      } else if (target.getAttribute('data-trigger') === 'cite' || target.getAttribute('data-trigger') === 'export') {
        (0, _utils.showTab)(target);
      } else if (target.getAttribute('data-trigger') === 'add-to-library') {
        if (_this3.zotero.config.zorgIntegration) {
          _this3.saveToMyLibrary(target, itemEl);
        }
      } else if (target.getAttribute('data-trigger') === 'expand-authors') {
        var creatorsEl = (0, _utils.closest)(target, function (el) {
          return el.classList.contains('zotero-creators');
        });
        creatorsEl.classList.add('zotero-creators-expanded');
        target.parentNode.removeChild(target);
      }
    }
  });
  this.container.addEventListener('change', function (ev) {
    var target = (0, _utils.closest)(ev.target, function (el) {
      return el.hasAttribute && el.hasAttribute('data-trigger');
    });
    var itemEl = (0, _utils.closest)(target, function (el) {
      return el.hasAttribute && el.hasAttribute('data-item');
    });

    if (target.getAttribute('data-trigger') === 'cite-style-selection') {
      _this3.updateCitation(itemEl);
    } else if (target.getAttribute('data-trigger') === 'export-format-selection') {
      _this3.prepareExport(itemEl);
    }
  });
  window.addEventListener('resize', (0, _debounce2.default)(this.updateVisuals).bind(this));
};
/**
 * Update .zotero-line to align with left border of the screen on small
 * devices, provided that the container is no more than 30px from the
 * border (and no less than 4px required for the actual line and 1px space)
 */


DomWrapper.prototype.updateVisuals = function () {
  var _this4 = this;

  if (!this.zoteroLines) {
    this.zoteroLines = this.container.querySelectorAll('.zotero-line');
  }

  (0, _each2.default)(this.zoteroLines, function (zoteroLineEl) {
    var offset = "".concat(_this4.container.offsetLeft * -1, "px");

    if (window.innerWidth < 768 && _this4.container.offsetLeft <= 30 && _this4.container.offsetLeft > 3) {
      zoteroLineEl.style.left = offset;
    } else {
      zoteroLineEl.style.left = null;
    }
  });
};
/**
 * Toggle CSS class that gives a visual loading feedback. Optionally allows to explicetly specify
 * whether to display or hide visual feedback.
 * @param  {boolean} [activate]    - Explicitely indicate whether to add or remove visual feedback
 */


DomWrapper.prototype.toggleSpinner = function (activate) {
  var method = activate === null ? this.container.classList.toggle : activate ? this.container.classList.add : this.container.classList.remove;
  method.call(this.container.classList, 'zotero-loading');
};
/**
 * Expand (if collapsed) or collapse (if expanded) item details. Optionally override to force
 * either expand or collapse
 * @param  {HTMLElement} itemEl 	- DOM element where item is
 * @param  {boolean} override 		- override whether to expand or collapse details
 */


DomWrapper.prototype.toggleDetails = function (itemEl, override) {
  var detailsEl = itemEl.querySelector('.zotero-details');

  if (detailsEl) {
    var expanded = (0, _utils.toggleCollapse)(detailsEl, override);

    if (expanded) {
      itemEl.classList.add('zotero-details-open');

      if (this.zotero.userId) {
        this.prepareExport(itemEl);
        this.updateCitation(itemEl, this.preferredCitationStyle);
      }
    } else {
      itemEl.classList.remove('zotero-details-open');
    }
  }

  if (this.config.useHistory) {
    window.history.pushState(null, null, "#".concat(itemEl.getAttribute('data-item')));
  }
};
/**
 * Expand item details based on the item id.
 * @param  {string} itemId
 */


DomWrapper.prototype.expandDetails = function (itemId) {
  var _this5 = this;

  return new Promise(function (resolve) {
    var itemEl = _this5.container.querySelector("[id=item-".concat(itemId, "]"));

    var scrollIntoView = function scrollIntoView() {
      itemEl.removeEventListener('transitionend', scrollIntoView);
      itemEl.scrollIntoView();
      resolve();
    };

    itemEl.addEventListener('transitionend', scrollIntoView);

    _this5.toggleDetails(itemEl, true);

    setTimeout(resolve, 500);
  });
};
/**
 * On Zotero.org adds item to currently logged-in user's library
 * @param  {HTMLElement} triggerEl 	- DOM Element that triggered saving, usually a button
 * @param  {HTMLElement} itemEl 	- DOM element where the item is located
 */


DomWrapper.prototype.saveToMyLibrary = function (triggerEl, itemEl) {
  var replacementEl = document.createElement('span');
  replacementEl.innerText = 'Adding...';
  triggerEl.parentNode.replaceChild(replacementEl, triggerEl);
  var itemId = itemEl.getAttribute('data-item');
  var sourceItem = (0, _find2.default)(this.data.raw, {
    'key': itemId
  });
  var clonedItem = {};
  var ignoredFields = ['mimeType', 'linkMode', 'charset', 'md5', 'mtime', 'version', 'key', 'collections', 'parentItem', 'contentType', 'filename', 'tags', 'dateAdded', 'dateModified'];
  (0, _each2.default)(sourceItem.data, function (value, key) {
    if (!(0, _includes.default)(ignoredFields, key)) {
      clonedItem[key] = value;
    }
  });

  if (!clonedItem.relations) {
    clonedItem.relations = {};
  }

  clonedItem.relations = {
    'owl:sameAs': "http://zotero.org/users/".concat(sourceItem.library.id, "/publications/items/").concat(itemId)
  };
  var writePromise = this.zotero.postItems(this.zotero.config.zorgIntegration.userID, [clonedItem], {
    key: this.zotero.config.zorgIntegration.apiKey
  });
  return new Promise(function (resolve, reject) {
    writePromise.then(function () {
      replacementEl.innerText = 'Added.';
      resolve();
    });
    writePromise.catch(function (err) {
      replacementEl.innerText = 'Error!';
      setTimeout(function () {
        replacementEl.parentNode.replaceChild(triggerEl, replacementEl);
      }, 2000);
      reject(err);
    });
  });
};

var _default = DomWrapper;
exports.default = _default;